import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography, CircularProgress } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import { useTranslation } from "react-i18next";

export function FixMeButton({handleFix}) {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);

    return <Button onClick={() => open == false ? setOpen(true) : null}>
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                <BuildIcon sx={{color: "white", display: "block"}} fontSize={'small'}/>
                <Typography variant="caption" color="common.white" sx={{fontWeight: "bold", textTransform: "capitalize", display: "block"}}>
                  {t("fixme.button")}
                </Typography>
              </Box>

              <FixMeDialog open={open} handleClose={() => setOpen(false)} handleFix={handleFix}/>
          </Button>
  }

export function FixMeDialog({open, handleClose, handleFix}) {
    const { t } = useTranslation();
    const [fixing, setFixing] = React.useState(false);

    return <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">
      {t("fixme.title")}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {t("fixme.body")}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose}>{t("common.close")}</Button>
      {!fixing ? <Button onClick={async () => {setFixing(true);
        try { if (await handleFix() !== false) handleClose(); }
        catch (error) { console.error("Failed to fix report:", error); }
        finally { setFixing(false); }}} autoFocus>
        {t("fixme.confirm")}
      </Button> : <CircularProgress />}
    </DialogActions>
  </Dialog>
}